import { useEffect, useRef, useState } from "react";
import IdleTimer from "react-idle-timer";
import { BrowserRouter as Router } from "react-router-dom";

import {
  Redirect,
  Route,
  Switch,
} from "react-router-dom/cjs/react-router-dom.min.js";
import { encryptStorage } from "../../constants/EncryptStorage";
import {
  clearAuthSession,
  IDLE_TIMEOUT_MS,
  isSessionIdleExpired,
  touchLastActivity,
} from "../../constants/authSession";
import UpdateToken from "../../UpdateToken";
import EventSpecialAttendanceCase from "../events/EventSpecialAttendanceCase.js";
import LoginSignUp from "../loginSignUp/LoginSignUp";
import Logout from "../logout/Logout";
import Layout from "../shared/Layout.js";
import { LoadingSpinner } from "../../constants/const.js";
import { GetLanguageString } from "../helper/Components.js";
import EventSummaryReport from "../events/report/EventSummaryReport/EventSummaryReport.js";

const LoginRedirect = () => {
  const [values, setValues] = useState(() => {
    const token = encryptStorage.getItem("token") || "";
    // Reopened after every tab was closed (or the device slept) for longer than the
    // idle timeout: do not resume the stored session.
    if (token && isSessionIdleExpired()) {
      clearAuthSession(true);
      return { token: "" };
    }
    return { token };
  });
  const [doLogout, setDoLogout] = useState(false);
  const [responsibilityChangeLoading, setResponsibilityChangeLoading] =
    useState(false);
  const eventId = encryptStorage.getItem("attendanceAccessEventId");
  const attendanceAccess = !!eventId && eventId !== "0";
  const idleTimerRef = useRef(null);

  useEffect(() => {
    if (values.token) touchLastActivity();
  }, [values.token]);

  if (!values.token) {
    return <LoginSignUp setValues={setValues} />;
  }

  const handleOnIdle = () => {
    // The shared timestamp is the source of truth: another tab may still be in use
    // even if this tab (or the cross-tab leader's view of the tabs) looks idle.
    if (isSessionIdleExpired()) {
      setDoLogout(true);
    } else {
      idleTimerRef.current?.reset();
    }
  };
  return (
    <Router>
      <IdleTimer
        ref={idleTimerRef}
        timeout={IDLE_TIMEOUT_MS}
        onIdle={handleOnIdle}
        onAction={touchLastActivity}
        throttle={5000}
        crossTab
      />
      <UpdateToken setDoLogout={setDoLogout} />

      {doLogout ? (
        <Logout setDoLogout={setDoLogout} sessionExpired={true} />
      ) : attendanceAccess && !responsibilityChangeLoading ? (
        <Switch>
          {/* Main attendance route */}
          <Route exact path="/barCodeAttendance">
            <EventSpecialAttendanceCase
              setResponsibilityChangeLoading={setResponsibilityChangeLoading}
            />
          </Route>

          {/* Summary report */}
          <Route exact path="/eventReports/summaryReport">
            <div
              style={{
                width: "100vw",
                height: "100vh",
                display: "flex",
                flexDirection: "column",
                background: "linear-gradient(135deg, #f8fafc, #e2e8f0)",
                overflow: "auto",
                transition: "background 0.4s ease",
              }}
            >
              <EventSummaryReport />
            </div>
          </Route>

          {/* Redirect everything else to attendance */}
          <Redirect to="/barCodeAttendance" />
        </Switch>
      ) : attendanceAccess && responsibilityChangeLoading ? (
        <div
          className="text-center"
          style={{
            backgroundColor: "white",
            width: "100vw",
            height: "100vh",
          }}
        >
          <br />
          <h2>{<GetLanguageString props={"responsibility_change_text"} />}</h2>
          {LoadingSpinner()}
        </div>
      ) : (
        <Switch>
          {/* Normal app layout */}
          <Route path="/">
            <Layout />
          </Route>
        </Switch>
      )}
    </Router>
  );
};

export default LoginRedirect;
